import { useEffect, useState } from 'react';

export function useFileDropDetector() {
  const [overlayVisible, setOverlayVisible] = useState(false);

  useEffect(() => {
    let depth = 0;

    const onDragEnter = (e) => {
      if (e.dataTransfer?.types?.includes(`Files`)) {
        depth += 1;
        setOverlayVisible(true);
      }
    };

    const onDragLeave = () => {
      depth = Math.max(0, depth - 1);
      if (!depth) setOverlayVisible(false);
    };

    const onDrop = () => {
      depth = 0;
      setOverlayVisible(false);
    };

    window.addEventListener(`dragenter`, onDragEnter);
    window.addEventListener(`dragleave`, onDragLeave);
    window.addEventListener(`drop`, onDrop);

    return () => {
      try {
        window.removeEventListener(`dragenter`, onDragEnter);
        window.removeEventListener(`dragleave`, onDragLeave);
        window.removeEventListener(`drop`, onDrop);
        // eslint-disable-next-line no-empty
      } catch (_) {}
    };
  }, []);

  return overlayVisible;
}
